import { Component } from 'react';
import {
  IconCheckCircle,
  IconX,
  colors,
  IconXCircle,
} from '@podiumhq/podium-ui';

import styles from './Toast.module.scss';

class Toast extends Component {
  state = {
    index: 0,
    toasts: [],
  };

  componentDidMount() {
    Toast.instance = this;
  }

  componentWillUnmount() {
    delete Toast.instance;
  }

  notify = (text, warning) => {
    const { index, toasts } = this.state;
    const toast = { id: index, text, warning };

    toasts.push(toast);

    this.setState({
      index: index + 1,
      toasts,
    });

    setTimeout(() => {
      this.setState({
        toasts: this.state.toasts.filter(({ id }) => id !== index),
      });
    }, 5000);
  };

  closeToast = id => {
    this.setState({
      toasts: this.state.toasts.filter(toast => toast.id !== id),
    });
  };

  render() {
    const { toasts } = this.state;

    return (
      <div className={styles.main}>
        {toasts.map(({ id, text, warning }) => (
          <div key={id} className={styles.toast}>
            <div className={styles.info}>
              <div className={styles.icon}>
                {!warning ? (
                  <IconCheckCircle size="large" color={colors.cobaltBlue} />
                ) : (
                  <IconXCircle size="large" color={colors.poppyRed} />
                )}
              </div>
              <span className={styles.text}>{text}</span>
            </div>
            <button
              className={styles.button}
              onClick={() => this.closeToast(id)}
            >
              <IconX color={colors.steel} />
            </button>
          </div>
        ))}
      </div>
    );
  }
}

const exports = {
  Component: Toast,

  notify(text, warning = false) {
    Toast.instance && Toast.instance.notify(text, warning);
  },
};

export default exports;
